import { AppPermission } from '@shared/permissions'
import { withAppPermission } from '@shared/permissions/PermissionDenied'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import DashboardContent from './onboardingGuide/DashboardContent'
import SetupComplete from './onboardingGuide/SetupComplete'
import { useDashboardData } from './onboardingGuide/useDashboardData'
import ResourcesSection from './resources/ResourcesSection'

const DashboardRoute: React.FC = () => {
  const { dismissGuide, relaunchGuide, isDismissed } = useDashboardData()
  const [isGuideCompleted, setIsGuideCompleted] = useState(false)
  const [shouldCollapse, setShouldCollapse] = useState(false)

  const handleDismissGuide = () => {
    dismissGuide()
    setIsGuideCompleted(true)
    // Start collapse sequence after width animation completes
    setTimeout(() => {
      setShouldCollapse(true)
    }, 2000)
  }

  const handleRelaunchGuide = () => {
    relaunchGuide()
    setIsGuideCompleted(false)
    setShouldCollapse(false)
  }

  return (
    <>
      {!isDismissed && <DashboardContent onDismissGuide={handleDismissGuide} />}
      <AnimatePresence>
        {isGuideCompleted && (
          <motion.div
            initial={{ height: 'auto' }}
            animate={{
              height: shouldCollapse ? 0 : 'auto',
            }}
            transition={{
              duration: shouldCollapse ? 0.8 : 1,
              ease: 'easeInOut',
            }}
            exit={{ height: 'auto' }}
            style={{
              display: 'flex',
              justifyContent: 'center',
              overflow: 'hidden',
            }}>
            <motion.div
              initial={{ opacity: 1, width: '100%' }}
              animate={{
                opacity: shouldCollapse ? 0 : 1,
                width: shouldCollapse ? '0%' : '60%',
              }}
              transition={{
                duration: shouldCollapse ? 0.8 : 1,
                ease: 'easeInOut',
              }}
              exit={{ opacity: 0, width: '100%' }}>
              <SetupComplete />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <ResourcesSection isGuideDismissed={isDismissed} onRelaunchGuide={handleRelaunchGuide} />
    </>
  )
}

export default withAppPermission('onboardingApp', AppPermission.OnboardingAppManage)(DashboardRoute)
